var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"affairs-list"},[_c('div',{staticClass:"filter-status"}),_c('div',{staticClass:"affairs-right-panel"},[_c('AuthorAffairsList',{attrs:{"taskList":_vm.taskAuthorList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }